<script lang="ts">
     export let isPaused = false;
     export let rootElement;
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 1;
    
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
  }
  
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 801.3 254.8" height="100%" width="100%">
  <g class:paused={isPaused}>
    <g class="shapes" bind:this={rootElement}>
  <g id="plank">
    <path
      fill="var(--hair)"
      d="m0 144 3-7 5-2a12 12 0 0 0 7-2 16 16 0 0 1 12-2 72 72 0 0 0 11 2 31 31 0 0 0 6 0c3 0 4 0 4-4 1-3 2-4 5-5 8-3 16-3 24-2 5 1 9-1 14-2 1 0 3-1 3 2a8 8 0 0 1-1 0c-14 6-28 12-43 12l-2 2a13 13 0 0 1-7 8c-7 5-8 15-1 21a48 48 0 0 0 15 9c2 1 5 2 6 5 3-4 7-6 12-6h1l8-5c6-3 11-6 17-7 3 0 1 2 1 2l-9 16-4 7c-1 2 0 4 2 6a98 98 0 0 0 10 9 10 10 0 0 1 4 5c2 6 0 9-7 11a45 45 0 0 1-7 1h-7l9 7a10 10 0 0 1 3 12 6 6 0 0 1-4 3c-13 4-27 6-42 3-12-2-22-7-29-18a27 27 0 0 1-5-15c0-7-3-14-4-21l-9-39-1-1ZM708 46c-1-1 0-1 1-1a22 22 0 0 0 12-4c10-6 21-9 32-10a34 34 0 0 0 4-1c12-3 21 2 31 8 3 2 5 7 6 11l6 21v14a33 33 0 0 0 1 13v4c-3 4-1 9 0 13v6c-3 5-6 6-13 4a42 42 0 0 1-11-6c4-4 6-9 5-15 0-3-2-5-4-6l-5 1c-1 2-3 2-5 1-2 0-3-2-4-4-3-5-7-8-14-7a13 13 0 0 1-1 0 24 24 0 0 1-16-7 8 8 0 0 1-2-6c0-2 0-3 3-4a20 20 0 0 0 7-2c4-2 7-7 6-11-1-6-8-10-14-6a15 15 0 0 1-7 2 21 21 0 0 0-10 3c-1 1-3 0-4-1a18 18 0 0 1-4-10Z"
    />
    <path
      d="M516 3h4c5-4 10-4 15-1a14 14 0 0 0 7 1l28 1c12 0 23 1 35 4 14 3 28 7 41 12 9 4 17 8 24 14a11 11 0 0 1 3 3c2 3 5 3 9 4l13 2a7 7 0 0 1 3 2c1 2 3 3 4 2h1l1 17c0 7-2 12-4 18-2 7-7 13-9 21a69 69 0 0 1-2 7l-1 13a20 20 0 0 0-1 4c0 3-2 5-5 6-4 1-5 4-6 7l-10 32a59 59 0 0 0-2 8c0 2-2 3-3 3a13 13 0 0 0-2 0l-7-2c-3 0-6-1-7-4s-2-3-4-1c-2 1-4 2-7 1l-4-2-18-6-8-2a4 4 0 0 0-4 0c-2 0-3-1-3-3a24 24 0 0 1 0-6 183 183 0 0 1 4-21c1-2 0-2-2-2-11 1-22-1-34-3h-25l-33 4-30 5-33 4c-6 0-6 0-6-6 1-3 2-7 1-10l2-17 5-34a275 275 0 0 1 5-27c3-10 1-21 0-31l-2-15a2 2 0 0 1 1-1c8 0 16 0 24 3l7 2a22 22 0 0 0 3-1c5-2 10-3 16-3a4 4 0 0 0 2-1c5-4 9-4 14-1Z"
      fill="var(--shirt)"
    />
    <path
      fill="var(--flesh)"
      d="M99 161c-6 1-11 4-17 7l-8 5h-1c-5 0-9 2-12 6-1-3-4-4-6-5a48 48 0 0 1-15-9c-7-6-6-16 1-21a13 13 0 0 0 7-8l2-2c15 0 29-6 43-12a8 8 0 0 0 1 0l10-4 35-16a88 88 0 0 1 29-6q28-3 57-3l10-2 39-13 38-14a5 5 0 0 1 3-1c-1 5 0 9 3 13l3 6a47 47 0 0 1 7 13c5 14 8 28 15 41-3 2-5 2-8 2l-15 3-26 4-26 2a82 82 0 0 1-17 0 45 45 0 0 0-10 0 45 45 0 0 1-15-1 58 58 0 0 0-29 1 252 252 0 0 1-43 8l-30 1a71 71 0 0 0-25 5Z"
    />
    <path
      d="M343 136c-7-13-10-27-15-41a47 47 0 0 0-7-13l-3-6c-3-4-4-8-3-13l5-3c1-1 3-2 2-4l1-1c18-7 35-16 51-25l30-18c9-5 18-6 27-7a132 132 0 0 1 18 0l2 15c1 10 3 21 0 31a275 275 0 0 0-5 27l-5 35-2 16c-18 10-38 14-59 17l-27 3c-2 0-3 0-2-2v-8l-1-2c-3 0-5 1-7-1Z"
      fill="var(--pants)"
    />
    <path
      fill="var(--flesh)"
      d="m604 167 8 2 18 6 4 2c3 1 5 0 7-1s3-2 4 1 4 4 7 4l7 2-2 7c0 2 0 3 2 3l24 4c5 0 9 2 13 3 6 2 10 1 14-4l6-7a11 11 0 0 1 8-4 49 49 0 0 1 13 0 4 4 0 0 1 4 2 9 9 0 0 0 9 5c2 0 2 1 2 3l-5 4v3a7 7 0 0 1 2 7 3 3 0 0 0 0 3c2 2 2 4 0 6a8 8 0 0 0-2 6 4 4 0 0 1-3 5 2 2 0 0 0-2 2l-2 4a18 18 0 0 1-7 1c-8 0-16 0-24-2a12 12 0 0 0-7 1l-26 9a230 230 0 0 1-34 8c-10 2-21 3-32 3-7-6-11-13-11-23v-27c1-13 2-25 5-38ZM688 123l1-13a69 69 0 0 0 2-7c2-8 7-14 9-21 2-6 4-11 4-18l-1-17 5-1a18 18 0 0 0 4 10c1 1 2 2 4 1a21 21 0 0 1 9-3 15 15 0 0 0 8-2c6-3 13 0 14 7 1 3-2 8-6 10a20 20 0 0 1-8 2l-3 4a8 8 0 0 0 3 6 24 24 0 0 0 16 7 13 13 0 0 0 1 0c7-1 11 2 14 7 1 2 2 4 4 4 2 1 4 1 5-1l5-1c2 1 4 3 4 6 1 6-1 11-5 15l-14 5c-5 2-10 3-15 2-2-1-4 1-6 2l-8 7a11 11 0 0 1-3 1c-4 2-7 0-8-3 0-2-1-2-3-2l-4 2c-2 1-3 1-5-1a1 1 0 0 0-2 0c-2 2-3 0-5-1-1-3-3-3-6-2-5 1-8-1-10-5Z"
    />
  </g>
</g>
</g>
{#if isPaused}
<svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
{/if}
</svg>